<main [cdkTrapFocus]="isTrapActive" cdkTrapFocusAutoCapture class="layout-panel-centered">
    <form [formGroup]="step3" class="panel overflowing">
        <header class="panel-header">
            <h1 class="sr-only" i18n="sr-only@@profile.setupGiverOffer.title">Registrierungsprozess</h1>
            <ol aria-label="Schritte" class="process-steps heading">
                <li class="completed d-none d-sm-flex">
                    <a i18n="@@profile.setupGiverOffer.profile" routerLink="/on-boarding/giver-profile">1. Profil</a>
                </li>
                <li class="completed d-none d-sm-flex">
                    <a i18n="@@profile.setupGiverOffer.information" routerLink="/on-boarding/giver-profile-details">2.
                        Angaben</a>
                </li>
                <li class="completed">
                    <a aria-current="step" i18n="@@profile.setupGiverOffer.assistance"
                       routerLink="/on-boarding/giver-offer">3. Assistenz</a>
                </li>
            </ol>
            <a class="cancel" i18n="@@profile.setupGiverOffer.btn.cancel" routerLink="/">Abbrechen</a>
        </header>
        <div class="panel-content needs-illustration">
            <p class="text" i18n="@@profile.setupGiverOffer.info.moreDetails">
                In welcher Region möchten Sie arbeiten? In welchen Bereichen möchten Sie persönliche Assistenz anbieten?
                Mit Hilfe der Auswahl können wir für Sie nach potentiellen Arbeitgeber/innen suchen.
            </p>

            <app-giver-offer [parentGroup]="step3"></app-giver-offer>

        </div>
        <div class="panel-footer">
            <button (click)="back()" class="button block-xs" i18n="@@profile.setupGiverOffer.btn.back" type="button">
                Zurück
            </button>
            <button (click)="submitForm()" [disabled]="isLoading$ | async" class="button primary block-xs"
                    i18n="@@profile.setupGiverOffer.btn.submit"
                    type="button">Registrieren
            </button>
            <app-spinner [visible]="isLoading$ | async" class="absolute"></app-spinner>
        </div>
    </form>
</main>
